/**
 * HealthcareService Facade
 *
 * Stable API surface for healthcare service operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import {
  upsertHealthcareService,
  batchUpdateHealthcareServices,
  type UpsertHealthcareServiceInput,
  type UpsertHealthcareServiceResult,
  type BatchUpdateHealthcareServicesInput,
  type BatchUpdateHealthcareServicesResult,
} from "@benchmark/core/actions";

/**
 * Creates a HealthcareService facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createHealthcareServiceFacade(medplum: MedplumClient) {
  return {
    /**
     * Create or update a healthcare service.
     * @agentic connections
     */
    upsert: (
      input: UpsertHealthcareServiceInput,
    ): Promise<UpsertHealthcareServiceResult> => {
      return upsertHealthcareService(medplum, input);
    },
    /**
     * Batch update healthcare services with shared field values.
     * @agentic connections
     */
    batchUpdate: (
      input: BatchUpdateHealthcareServicesInput,
    ): Promise<BatchUpdateHealthcareServicesResult> => {
      return batchUpdateHealthcareServices(medplum, input);
    },
  };
}
